import { type UseMutationResult, useMutation } from 'react-query';
import { ParticipantService } from '../../services/wealthlane-customer-services';

const useGetRetirementEligibleParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setModalData: any,
  openModal: () => void
): UseMutationResult<any, unknown, void, unknown> => {
  return useMutation(
    async () => {
      return await handleRequest(
        ParticipantService.getApiCustomerApiAppParticipantRetirementEligibleParticipants()
      );
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          setModalData(response);
          openModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetRetirementEligibleParticipantList;
